import { render, staticRenderFns } from "./CreateDebt.vue?vue&type=template&id=501fdef7&scoped=true"
import script from "./CreateDebt.vue?vue&type=script&lang=js"
export * from "./CreateDebt.vue?vue&type=script&lang=js"
import style0 from "./CreateDebt.vue?vue&type=style&index=0&id=501fdef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fdef7",
  null
  
)

export default component.exports